export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9961.9373d283.jpg";